import { Editor, Range } from '@tiptap/core';

export const allowedOnlyInStartOfLine = (editor: Editor, range: Range) => {
  const $pos = editor.state.doc.resolve(range.from);
  const isParagraph = $pos.parent.type.name === 'paragraph';
  const startsWithSlash = $pos.parent.textContent?.charAt(0) === '/';

  return isParagraph && startsWithSlash;
};
export const isAllowedOnlyAtFirstLevel = (editor: Editor, range: Range) => {
  const $pos = editor.state.doc.resolve(range.from);
  const isParagraph = $pos.parent.type.name === 'paragraph';
  const isDoc = $pos.parent.type.name === 'doc';
  const startsWithSlash = $pos.parent.textContent?.charAt(0) === '/';

  return isDoc || (isParagraph && startsWithSlash && $pos.depth === 1);
};
